import React from 'react';
import classNames from 'classnames';
import CircularProgress from './CircularProgress';
import styles from './ProgressIndicator.module.css';

function ProgressIndicator({ className, ...rest }) {
  return (
    <div data-testid="progress" className={classNames(styles.root, className)} {...rest}>
      <CircularProgress />
    </div>
  );
}

export default ProgressIndicator;
